import { render, staticRenderFns } from "./base-form.vue?vue&type=template&id=548b06e8&"
import script from "./base-form.vue?vue&type=script&lang=js&"
export * from "./base-form.vue?vue&type=script&lang=js&"
import style0 from "./base-form.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports